import React from "react";
import Money from "../assets/Blackwomen/Copy-of-Website-Launch-Graphics-1-2.jpg";
import KatieImg from "../assets/Services/Booking App Template.png";
import BlueWillowImg from "../assets/Services/Waitlist App Template.png";

const projects = [
  {
    title: "Money On Mind",
    image: Money,
    url: "/moneyOnMind",
  },
  {
    title: "Booking App Template",
    image: KatieImg,
    url: "https://woaomtemplatetwo.web.app",
  },
  {
    title: "Waitlist App Template",
    image: BlueWillowImg,
    url: "https://serenity-studio-template.web.app",
  },
];

const FeaturedProjects = () => {
  return (
    <section className="py-16 bg-[#F7F3F2] text-center">
      <h2 className="text-4xl text-black font-semibold mb-12 italic">FEATURED PROJECTS & TEMPLATES</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 px-6 md:px-12 max-w-7xl mx-auto">
        {projects.map((project, idx) => (
          <div key={idx} className="space-y-4">
            <img
              src={project.image}
              alt={project.title}
              className="rounded-md shadow-md w-full h-auto"
            />
            <h3 className="text-xl italic text-black">{project.title}</h3>
            <a
              href={project.url}
              className="text-[#7F7E75] text-sm tracking-wide uppercase font-medium hover:underline"
            >
              View Project →
            </a>
          </div>
        ))}
      </div>
      <div className="mt-12">
        <a
          href="/clientwork"
          className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
        >
          Browse Client Work
        </a>
      </div>
    </section>
  );
};

export default FeaturedProjects;
